import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { DiamondMethod } from './pages/DiamondMethod';
import { Landing } from './pages/Landing';
import { Gracias } from './pages/Gracias';
import { MetaPixelRouteTracker } from './components/analytics/MetaPixelRouteTracker';
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2rkx67l5bqppn">
      <BrowserRouter data-id="element-1" data-mp="2rlozuqfd2dda">
        <MetaPixelRouteTracker data-id="element-2" data-mp="2rl6t2zv2ogr4" />
        <Routes data-id="element-3" data-mp="2mlu5ue0ah7o0">
          <Route path="/" element={<DiamondMethod data-id="element-5" data-mp="2mn5bkjdaophr" />} data-id="element-4" data-mp="2mmcc83go129n" />
          <Route path="/evaluacion" element={<Landing data-id="element-7" data-mp="31agq8u4rwpm3" />} data-id="element-6" data-mp="2mjpwhgjmfggc" />
          <Route path="/gracias" element={<Gracias data-id="element-9" data-mp="31c1iue7j1yhb" />} data-id="element-8" data-mp="31bs0ncsq4vm6" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-11" data-mp="2wjgtppzkg9k4" />} data-id="element-10" data-mp="2wk09b01quluz" />
        </Routes>
      </BrowserRouter>
    </MotionConfig>;
}